import React,{useState} from 'react';
import {Alert,Box,Button,CircularProgress,TextField,Typography} from '@mui/material';
import {useTelegramAuth} from '../../contexts/TelegramAuthContext';
import UserSessions from './UserSessions';
export default function TelegramRoute({children}:{children:React.ReactNode}){
 const {isAuthenticated,isLoading,isTelegram,error,login,recover}=useTelegramAuth();
 const [code,setCode]=useState('');
 if(isLoading)return <Box sx={{p:4}}><CircularProgress aria-label="Проверка входа"/></Box>;
 if(!isAuthenticated)return <Box sx={{p:4,maxWidth:600,mx:'auto'}}>
 <Typography variant="h5">Вход в приложение</Typography>{error&&<Alert severity="error">{error}</Alert>}
 <Typography>Откройте приложение из доверенного Telegram-бота. Если данные входа устарели, закройте и откройте Mini App заново.</Typography>
 {isTelegram&&<Button onClick={()=>void login()}>Войти через Telegram</Button>}
 <Typography>Или используйте одноразовый код, созданный в действующей сессии. Он действует 15 минут. Восстановление завершит прежние сессии.</Typography>
 <TextField label="Код восстановления" value={code} onChange={e=>setCode(e.target.value)} autoComplete="off" fullWidth/>
 <Button disabled={!/^[A-Za-z0-9_-]{43}$/.test(code)} onClick={()=>{const submitted=code;setCode('');void recover(submitted);}}>Восстановить доступ</Button>
 </Box>;
 return <><UserSessions/>{children}</>;
}
